/**
 *  jQuery Editorial Pod Plugin for Scout.com.
 */

(function ($, window, document, undefined) {

	'use strict';

	// Plugin Defaults
	var pluginName = 'editorialPod';
	var defaults = {
		propertyName: 'value'
	};

	/**
	 * Constructor
	 * @param {Object} options Config object passed in via plugin constructor.
	 */
	function EditorialPod (element, options) {

		// general vars
		this.element = $(element);
		this.settings = $.extend( {}, defaults, options );
		this._defaults = defaults;
		this._name = pluginName;

		// plugin specific vars
		this.activeSlide = 0;
		this.hammertime = this.element.hammer();
		this.viewport = this.element.find('.ep-viewport');
		this.width = this.viewport.width();
		this.slider = this.element.find('.slider');
		this.items = this.element.find('.slider li');
		this.len = this.items.length;
		this.isAnimating = false;
		this.autoScrollTime = 7000;
		this.autoScrollId = null;
		// init
		if (this.items.length > 1) this.init();
	}

	/**
	 * Plugin Functions.
	 */
	EditorialPod.prototype = {
		/**
		 * Init Function, called upon instantiation.
		 */
		init: function () {
			this.cloneItems();
			this.addEventListeners();
			this.startAutoSroll();
		},
		/**
		 * Registers all event handlers of the plugin.
		 */
		addEventListeners: function() {
			var self = this;
			this.hammertime.on('drag', $.proxy(this.onSwipe, this));
			this.element.find('.ep-nav a').on('click', function(e) {e.preventDefault(); self.onNavClick($(this));});
			$(window).on('resize', $.proxy(this.onResize, this));
			this.element.on('mouseover', $.proxy(this.stopAutoSroll, this));
			this.element.on('mouseout', $.proxy(this.startAutoSroll, this));
		},
		/**
		 * Workaround for poor swipe detection on Android devices.
		 */
		onSwipe: function(event) {
			var direction = event.gesture.direction;
			if (direction === 'left'){
				this.slideToNext();
				event.gesture.preventDefault();
			}else if(direction === 'right'){
				this.slideToPrev();
				event.gesture.preventDefault();
			}
			event.gesture.stopDetect();
		},
		/**
		 * Starts automatic scrolling.
		 */
		startAutoSroll: function() {
			var self = this;
			var isMobile = $('#header-mobilenav').is(':visible');

			if (this.autoScrollId) {
				clearInterval(this.autoScrollId);
			}
			if (!isMobile) {
				this.autoScrollId = setInterval(function(){self.slideToNext();}, this.autoScrollTime);
			}
		},
		/**
		 * Stops automatic scrolling.
		 */
		stopAutoSroll: function() {
			if (this.autoScrollId) {
				clearInterval(this.autoScrollId);
			}
		},
		/**
		 * Resets the automatic scrolling timer back to the maximum countdown.
		 */
		resetAutoScrollTimer: function() {
			this.startAutoSroll();
		},

		/**
		 * Clones items, to fill the browser horizontally.
		 */
		cloneItems: function() {
			// remove classnames
			this.slider.find('li').each(function (index) {
				$(this).removeClass();
				$(this).attr('data-index', index);
				$(this).attr('data-slide', index);
			});

			// clone items to fill the browser viewport
			var i, index, item;
			// clone left
			for (i = 0; i < 1; i++) {
				index = (i === 0) ? 0 : i % this.len;
				var reverseIndex = this.len - 1 - index;
				item = $(this.items[reverseIndex]);
				this.slider.prepend(item.clone(true).addClass('clone').attr('data-slide', reverseIndex).attr('data-index', (-1 - i)));
			}
			//clone right side
			for (i = 0; i < 1; i++) {
				index = (i === 0) ? 0 : i % this.len;
				item = $(this.items[index]);
				this.slider.append(item.clone(true).addClass('clone').attr('data-slide', index).attr('data-index', (this.len + i)));
			}

			// remove last and first
			this.slider.find('.first').removeClass('first');
			this.slider.find('.last').removeClass('last');
			this.slider.find('li').css('display', 'block');
			// set position
			this.setSlides();
		},
		/**
		 * Activates the next slide of the ep.
		 */
		slideToPrev: function (e) {
			if (e) {
				e.preventDefault();
			}
			if (!this.isAnimating){
				this.activeSlide--;
				if (this.activeSlide <= -1) {
					this.activeSlide = this.len;
					this.setSlides();
					this.activeSlide = this.len - 1;
				}
				this.animateSlides();
			}
		},
		/**
		 * Activates the previous slide of the ep.
		 */
		slideToNext: function (e) {
			if (e) {
				e.preventDefault();
			}
			if (!this.isAnimating){
				this.activeSlide++;
				if (this.activeSlide >= this.len) {
					this.activeSlide = -1;
					this.setSlides();
					this.activeSlide = 0;
				}
				this.animateSlides();
			}
		},
		/**
		 * Moves the slide to the current position with animation.
		 */
		animateSlides: function () {
			var self = this;
			self.isAnimating = true;

			this.slider.find('li').each(function () {
				var index = parseInt($(this).attr('data-slide'), 10);
				$(this).toggleClass('active', (index === self.activeSlide));
			});

			var posX = (0 - self.activeSlide) * self.width;
			var posXPx = posX.toString() + 'px';
			//this.slider.css('left', posXPx);
			this.slider.animate({left: posXPx}, 400, function(){
				self.isAnimating = false;
			});

			this.element.find('.ep-nav li').each(function (index){
				$(this).toggleClass('active', (index === self.activeSlide));
			});
		},
		/**
		 * Moves the slide to the current position instantly.
		 */
		setSlides: function () {
			var self = this;

			this.slider.find('li').each(function () {
				var index = parseInt($(this).attr('data-index'), 10);
				var posX = index * self.width;
				var posXPx = posX.toString() + 'px';
				$(this).css('left', posXPx);
				$(this).toggleClass('active', (index === self.activeSlide));

				// vertically center aligh
				var h = $(this).find('.content').height() + 'px';
				$(this).find('.vert-center').css('height', h);
			});


			var posX = (0 - self.activeSlide) * self.width;
			var posXPx = posX.toString() + 'px';
			this.slider.css('left', posXPx);
		},
		/**
		 * Gets called upon browser resize.
		 */
		onResize: function () {
			this.width = this.viewport.width();
			this.setSlides();
		},
		/**
		 * Gets called upon click on bottom ep nav (ep pagination).
		 */
		onNavClick: function (el) {
			if (!this.isAnimating){
				this.activeSlide = $(el).attr('data-index') * 1;
				this.animateSlides();
			}
		}

	};

	// Plugin wrapper around the constructor, preventing against multiple instantiations.
	$.fn[ pluginName ] = function (options) {
		this.each(function() {
			if (!$.data( this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new EditorialPod(this, options));
			}
		});
		// chain jQuery functions
		return this;
	};

})( jQuery, window, document );